import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, ThemeProvider } from 'styled-components';
import { gray10, gray95 } from '@spotify-internal/encore-foundation';
var NavBarPanel = styled.div.withConfig({
  displayName: "NavBar__NavBarPanel",
  componentId: "sc-1oliuie-0"
})(["", ";"], function (props) {
  return css(["color:", ";"], props.theme.navBar === 'dark' ? gray95 : gray10);
});
var propTypes = {
  list: PropTypes.node,
  children: PropTypes.node,
  theme: PropTypes.shape({
    navBar: PropTypes.oneOf(['dark'])
  })
};
var defaultProps = {
  theme: {}
};
export default function NavBar(_ref) {
  var list = _ref.list,
      children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["list", "children", "theme"]);

  return React.createElement(ThemeProvider, {
    theme: theme
  }, React.createElement("section", props, list, React.createElement(NavBarPanel, null, children)));
}
NavBar.propTypes = propTypes;
NavBar.defaultProps = defaultProps;
NavBar.darkTheme = {
  navBar: 'dark'
};